import { apiClient } from '@/lib/api/client';

export async function getDealerList(params = {}, config) {
    return apiClient.get('/dealer/list', Object.assign(Object.assign({}, config), { params: {
            keyword: params.keyword,
            cityId: params.cityId,
            sort: params.sort,
            pageNum: params.page,
            pageSize: params.size
        }}));
}

export async function getDealerDetail(id) {
    return apiClient.get(`/dealer/${id}`);
}

export async function getDealerListings(id) {
    return apiClient.get(`/dealer/${id}/listings`);
}

export async function getCityList() {
    return apiClient.get('/dict/city');
}

export const dealerApi = {
    dealerList: getDealerList,
    dealerDetail: getDealerDetail,
    dealerListings: getDealerListings,
    cityList: getCityList,
};
export default dealerApi;